'use strict';

const translateCountry = require('../../../custom_components/js/country-translator');

module.exports = /* @ngInject */ function() {
    return {
        restrict: 'E',
        scope: {
            /**
             * Currently only "SHIPPING" is supported. "INVOICE" will be implemented later
             */
            address: '=',
            language: '=',
            searchString: '='
        },
        templateUrl: `./${BUILD_PATH}/address.directive.html`,
        controller: /* @ngInject */ function ($scope) {
            init();

            function init(){
                    if($scope.address) {
                        $scope.companyNameLine1 = $scope.address?.companyAddressWithContact?.companyAddress?.companyName?.line1;
                        $scope.companyNameLine2 = $scope.address?.companyAddressWithContact?.companyAddress?.companyName?.line2;
                        $scope.street = $scope.address?.companyAddressWithContact?.companyAddress?.address?.street;
                        $scope.zip = $scope.address?.companyAddressWithContact?.companyAddress?.address?.zip;
                        $scope.city = $scope.address?.companyAddressWithContact?.companyAddress?.address?.city;
                        $scope.state = $scope.address?.companyAddressWithContact?.companyAddress?.address?.state;
                        $scope.emailAddress = $scope.address?.companyAddressWithContact?.companyAddress?.emailAddress?.value;
                        $scope.firstname = $scope.address?.companyAddressWithContact?.personName?.firstname;
                        $scope.lastname = $scope.address?.companyAddressWithContact?.personName?.lastname;
                        $scope.country = translateCountry($scope.address?.companyAddressWithContact?.companyAddress?.address?.country, $scope.language);
                    }
            }
        }
    };
};
